// @ts-nocheck

import MainDispatcher from '../support/MainDispatcher';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import type { TuneExportPayload } from '../types/customExportTypes';
const EXPORT_PATH = '/v1/tune-custom-export';
const CreateTuneCustomExport = new ReduxAsyncAction('CREATE_TUNE_CUSTOM_EXPORT');
CreateTuneCustomExport.registerRequest((params: TuneExportPayload) => {
  return dash_api
    .post(EXPORT_PATH, params)
    .then(({ data }) => data)
    .catch(() =>
      MainDispatcher.dispatch({
        action: 'EXPORT_CREATION_ERROR',
        error: 'Error creating export.',
      })
    );
});
export const CREATE_TUNE_CUSTOM_EXPORT = CreateTuneCustomExport.constants;
export const createTuneCustomExport = CreateTuneCustomExport.request;
const RetrieveTuneCustomExports = new ReduxAsyncAction('RETRIEVE_TUNE_CUSTOM_EXPORTS');
RetrieveTuneCustomExports.registerRequest(() => {
  return dash_api
    .get(EXPORT_PATH)
    .then(({ data }) => data)
    .catch(() =>
      MainDispatcher.dispatch({
        action: 'EXPORT_RETRIEVAL_ERROR',
        error: 'Error retrieving exports.',
      })
    );
});
export const RETRIEVE_TUNE_CUSTOM_EXPORTS = RetrieveTuneCustomExports.constants;
export const retrieveTuneCustomExports = RetrieveTuneCustomExports.request;
